module.exports = __webpack_public_path__ + "static/media/CC4-0.3add86e1.jpg";